export default __webpack_public_path__ + "static/media/loreal.428ba2f4.jpg";